export default __webpack_public_path__ + "4c8940329a88a9ef428f81084037336c.svg";